import React from 'react';
import type { ReachabilityValue } from '../../types';

// Phase 1 — reachability axis (four-axis lead status model, 2026-09-20).
export const REACHABILITY_COLORS: Record<ReachabilityValue, { bg: string; fg: string }> = {
  unattempted: { bg: '#f1f5f9', fg: '#64748b' }, // slate — no signal yet
  attempted:   { bg: '#e2e8f0', fg: '#334155' }, // grey
  unreached:   { bg: '#fee2e2', fg: '#991b1b' }, // red — needs attention
  reached:     { bg: '#dcfce7', fg: '#166534' }, // green
  do_not_call: { bg: '#1e293b', fg: '#f8fafc' }, // dark — hard stop
};

export const REACHABILITY_LABELS: Record<ReachabilityValue, string> = {
  unattempted: 'Unattempted',
  attempted:   'Attempted',
  unreached:   'Unreached',
  reached:     'Reached',
  do_not_call: 'Do Not Call',
};

interface Props {
  reachability: ReachabilityValue;
  attempts?: number;
  compact?: boolean;
}

const ReachabilityBadge: React.FC<Props> = ({ reachability, attempts, compact }) => {
  const c = REACHABILITY_COLORS[reachability] ?? REACHABILITY_COLORS.unattempted;
  const label = REACHABILITY_LABELS[reachability] ?? reachability;
  const showAttempts = reachability !== 'unattempted' && reachability !== 'do_not_call' && !!attempts;

  const style: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    background: c.bg,
    color: c.fg,
    borderRadius: 999,
    padding: compact ? '2px 8px' : '4px 12px',
    fontSize: compact ? 11 : 12,
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: 0.2,
    userSelect: 'none',
  };

  return (
    <span style={style} title={`Reachability: ${label}${showAttempts ? ` (${attempts} attempts)` : ''}`}>
      {label}
      {showAttempts && <span style={{ opacity: 0.75, fontWeight: 500 }}>· {attempts}</span>}
    </span>
  );
};

export default ReachabilityBadge;
